var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "go-modal-event-plugin",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-event" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              {
                staticClass: "go-block-header",
                staticStyle: {
                  "background-image":
                    "url('/content/images/images_v3/common/go-help/go-help-plugin-img01.png')",
                },
              },
              [
                _c("h1", [
                  _c("small", [
                    _vm._v(_vm._s(_vm.$t("home.chromeExtension.text1-1"))),
                  ]),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("home.chromeExtension.text1-2"))),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "go-block-body" }, [
              _c("p", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("home.chromeExtension.text2")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("home.chromeExtension.text3")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("home.chromeExtension.text4")))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                attrs: { type: "button", "data-dismiss": "modal" },
              },
              [_vm._v(_vm._s(_vm.$t("home.chromeExtension.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn go-btn-primary",
                attrs: {
                  type: "button",
                  href: "https://chromewebstore.google.com/detail/goover/cpgndeiekofpnkdlbcahkfbcnebadgmg?hl=ko",
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.$t("home.chromeExtension.store")))]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }